//import logo from "./logo.svg";
import "./App.css";
import Todo from "./Todo2";
import { LoadingPage } from "./loading/LoadingPage";

import { NavigationBar } from "./navigation/NavigationBar";

import React, { useState, useEffect } from "react";
import {
  Container,
  List,
  Paper,
  //Grid,
  //Button,
  //AppBar,
  //Toolbar,
  //Typography,
} from "@mui/material";
import AddTodo from "./AddTodo";
import { call, signout } from "./service/ApiService";

export function App() {
  const [items, setItems] = useState([
    /*
    {
      id: "0",
      title: "text writing1",
      done: true,
    },
    {
      id: "1",
      title: "text writing2",
      done: true,
    },
    */
  ]);

  /* 상태값 0 :정상, 1:로딩중, 2:장애 발생 */
  const [loading, setLoading] = useState(1);

  /*
  useEffect(() => {
    //콜백함수
    const requestOptions = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      //body : JSON.stringify(data),
    };

    fetch("http://localhost:8080/todo", requestOptions)
      .then((response) => response.json())
      .then(
        (response) => {
          setItems(response.data);
        },
        (error) => {}
      );
  }, []);
  */
  useEffect(() => {
    //effect 훅 //랜더링 후에 수행 이후  []의 오브젝트가 변경되면 수행
    call("/todo", "GET", null).then((response) => {
      if (response) {
        setItems(response.data);
        setLoading(0);
      }
    });
  }, []);

  /*
  if (loading != 0) {
    let timer = setTimeout(() => {
      setLoading(2);
      //alert("!SE");
    }, 4000);
  }
  */

  /*
  let timeout = 4000;
  useEffect(() => {
    const idleTimer = setTimeout(() => {
      setLoading(2);
    }, timeout);

    return function cleanup() {
      clearTimeout(idleTimer);
    };
  }, [items, timeout]);
  */

  /*
  const addItem = (item) => {
    item.id = "ID-" + items.length; // key를 위한 id
    item.done = false; // done 초기화
    // 업데이트는 반드시 setItems로 하고 새 배열을 만들어 주어야 한다.
    setItems([...items, item]);
    console.log("items : ", items);
  };
  */
  const addItem = (item) => {
    call("/todo", "POST", item).then((response) => {
      if (response.error === "empty_title") {
        alert("값이 비어 있어요.");
      } else {
        setItems(response.data);
      }
    });
  };

  /*
  const editItem = () => {
    setItems([...items]);
  };
  */
  const editItem = (item) => {
    call("/todo", "PUT", item).then((response) => setItems(response.data));
  };

  /*
  const deleteItem = (item) => {
    // 삭제할 아이템을 찾는다.
    const newItems = items.filter((e) => e.id !== item.id);
    // 삭제할 아이템을 제외한 아이템을 다시 배열에 저장한다.
    setItems([...newItems]);
  };
  */
  const deleteItem = (item) => {
    call("/todo", "DELETE", item).then((response) => setItems(response.data));
  };

  let subject = "메모장";
  let navigationBar = NavigationBar(subject);

  let todoItems = items.length > 0 && (
    <Paper style={{ margin: 16 }}>
      <List>
        {items.map((item) => (
          <Todo
            item={item}
            key={item.id}
            editItem={editItem}
            deleteItem={deleteItem}
          />
        ))}
      </List>
    </Paper>
  );

  /* 로딩중이 아닐 때 렌더링 할 부분 */
  let todoListPage = (
    <div>
      {navigationBar} {/* 네비게이션 바 렌더링 */}
      <Container maxWidth="md">
        <AddTodo addItem={addItem} />
        <div className="TodoList">{todoItems}</div>
      </Container>
    </div>
  );

  /* 로딩중일 때 렌더링 할 부분 */
  //let loadingPage = <h1> 로딩중.. </h1>;
  let loadingPage = (
    <div>
      <LoadingPage />
    </div>
  );
  let loadingPage2 = <h1> 일시적 장애.. </h1>;
  let content = loadingPage;

  if (loading === 0) {
    /* 로딩중이 아니면 todoListPage를 선택*/
    content = todoListPage;
  } else if (loading === 2) {
    content = loadingPage2;
  } else if (loading === 1) {
    content = loadingPage;
  } else {
    content = loadingPage;
  }

  /* 선택한 content 렌더링 */
  return <div className="App">{content}</div>;

  /*
  return (
    <div className="App">
      {navigationBar} 
      <Container maxWidth="md">
        <AddTodo addItem={addItem} />
        <div className="TodoList">{todoItems}</div>
      </Container>
    </div>
  );
  */
}

export default App;
